import { render, staticRenderFns } from "./CartaoInformacoesPrestador.vue?vue&type=template&id=3042f04a&scoped=true"
import script from "./CartaoInformacoesPrestador.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesPrestador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3042f04a",
  null
  
)

export default component.exports